import { Controller } from "@hotwired/stimulus";
import { runInit } from "../campaign_onboarding";

/**
 * Wires campaign onboarding buttons when this controller connects.
 * Running init on connect fixes Turbo: after navigation the new body
 * is in the DOM and connect() runs, so buttons get their listeners.
 */
export default class CampaignOnboardingController extends Controller {
  connect() {
    console.log(
      "[campaign-onboarding] controller connect(), element:",
      this.element,
      "data-controller:",
      this.element?.dataset.controller,
    );
    runInit(this.element);
  }
}
